import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Button from '@stone/ui/button/Button';
const LoginEditEmail = (props) => {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(props.singleColumn ? 'col-24' : 'col-24 col-lg-16', 'edit-email') },
            React.createElement("p", { className: "edit-email-greethings" },
                React.createElement("span", null,
                    t('account.welcomeback'),
                    " "),
                React.createElement("b", null, props.loginEmail)),
            props.description || React.createElement("p", { className: classNames({ 'visually-hidden': props.emailOnly }) }, t('login.insertpassword'))),
        props.onClick && (React.createElement("div", { className: props.singleColumn ? 'col-24 mt-12' : 'col-24 col-lg-8 text-lg-right edit-email-button' },
            React.createElement(Button, { cls: ['button--tertiary'], onClick: () => props.onClick(), type: 'button' }, t('login.editemail'))))));
};
export default LoginEditEmail;
